<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import router from './router'

// IE時、非表示される問題を解消
if (!String.prototype.includes) {
    String.prototype.includes = function() {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

export default {
  name: 'App',
  watch: {
    '$route': {
      handler (to) {
        this.setPageMetaInfo(to)
      }
    }
  },
  methods: {
    setPageMetaInfo (to) {
      if (to.meta['title']) document.title = to.meta['title']
      if (to.meta['desc']) {
        document.querySelector("meta[name='description']").setAttribute('content', to.meta['desc'])
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', sans-serif;
}
</style>
